export default __webpack_public_path__ + "static/7-42ac33f66becb66abee1f754ab8f1676.png";